import React, {
    useCallback,
    useState,
} from 'react';
import { buildClassNames } from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import IconButton from '@frontend/jetlend-web-ui/src/ui/inputs/IconButton/IconButton';
import { IAchievementItemApiModel } from '@app/models/features/course';
import shareIcon from '@app/icons/share-icon.svg';
import AchievementShareButtons from './AchievementShareButtons';

import styles from './achievementShareButtons.module.scss';

type Props = Pick<IAchievementItemApiModel, 'icon' | 'referral_link' | 'referral_title'>;

/**
* Обертка с состоянием компонента для отображение кнопок шаринга в соц. сетях
* И кнопки копирования в буфер отмена
*/
const AchievementShareButtonsContainer = (props: Props) => {
    const {
        icon,
        referral_link,
        referral_title,
    } = props;

    const [isShareButtonsShow, setShareButtonsShow] = useState(false);

    const didShareButtonChanged = useCallback(() => setShareButtonsShow(prev => !prev), []);
    const didShareButtonsClosed = useCallback(() => setShareButtonsShow(false), []);

    const sharedButtonsClassName = buildClassNames(styles, [
        'shared-buttons',
        !isShareButtonsShow && 'shared-buttons--hide',
    ]);

    return (
        <>
            {referral_link && (
                <IconButton
                    icon={shareIcon}
                    containerClassName={styles['icon-button']}
                    iconClassName={styles['share-icon']}
                    onClick={didShareButtonChanged}
                    margin="left"
                />
            )}
            <div className={sharedButtonsClassName}>
                <AchievementShareButtons
                    onClose={didShareButtonsClosed}
                    referral_link={referral_link}
                    referral_title={referral_title}
                    icon={icon}
                />
            </div>
        </>
    );
};

export default AchievementShareButtonsContainer;
